export function totalPages(total: number, pageSize: number): number {
  return Math.max(1, Math.ceil(Math.max(0, total) / Math.max(1, pageSize)))
}

export function isConflictError(error: unknown): boolean {
  return problemOf(error)?.status === 409
}

export function apiErrorMessage(error: unknown, fallback: string): string {
  const problem = problemOf(error)
  return problem?.detail ?? problem?.title ?? fallback
}

function problemOf(error: unknown): { status?: number; detail?: string; title?: string } | null {
  if (!error || typeof error !== 'object') return null
  const problem = (error as { problem?: unknown }).problem
  if (!problem || typeof problem !== 'object') return null
  return problem as { status?: number; detail?: string; title?: string }
}

export function parseLocaleNumber(value: string): number | null {
  const normalized = value.trim().replace(/\s/g, '').replace(/\.(?=\d{3}(?:\D|$))/g, '').replace(',', '.')
  const number = Number(normalized)
  return normalized && Number.isFinite(number) ? number : null
}

export function maskPii(value: string | null | undefined): string {
  return value ? 'Informação protegida' : '—'
}
